import axios from '.';

export default {
  setupMasspayUser,
};

async function setupMasspayUser() {
  const response = await axios.get('/api/masspay/users/setup');
  return response.data;
}
